import { motion } from 'framer-motion';
import { styled } from 'styled-components';

import { styledReset } from '@pkg/primitives';

interface StyledOnboardPopoverProps {
    $top?: number;
    $left?: number;
    $right?: number;
}

export const StyledOnboardPopover = styled(motion.div)<StyledOnboardPopoverProps>`
    ${styledReset.borderBox};
    z-index: 201;
    min-width: 300px;
`;
